import { Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Link as RouterLink } from 'react-router-dom';
import { RootState } from "../store";

export default function MainNavigationItem(params: { name: string, path: string }) {
    // Check if navigation item is active and change color accordingly
    const nav = useSelector((state: RootState) => state.navigation.value);
    const active = (params.path === nav) || (nav === "gallery" && params.path.startsWith(nav)) || (nav === "books" && params.path.startsWith(nav));
    let col = "black";
    if (active) col = "#b7979c";

    return (
        <Button component={RouterLink} to={"/" + params.path} sx={{ ':hover': { bgcolor: 'kr.main' }, color: col, padding: "0px", marginRight: "3.4%", textTransform: 'none' }}>
            <Typography variant="subtitle1">
                {params.name}
            </Typography>
        </Button>
    );
}